<template>
    <div>
        <!--middle middle section-->
        <div class="main-internal-section width-full float-l">
            <div class="container">
                <template v-if="cantAccessPage === true">
                    <div class="row">

                        <div class="chat-btm-section-main add-user-main-section width-full float-l"> <!--middle section-->
                            <div class="web-add-form float-l width-full">
                                <h2 class="chat-page-title float-l colpie-80 color-333333 heading-text-18 line-height-22 font-bold ucase"> Update User </h2>

                                <div class="add-user-form width-full float-l mt_10 ">
                                    <div class="top-label-section update-user-top-section float-l width-full"> <!--top section-->
                                        <div class="form-group float-l width-full p_15">
                                            <p class="select-box-label color-888888 heading-text-13 line-height-17 font-benton-book mb_0"> Name </p>
                                            <input type="text" class="form-control custom-select" :placeholder="name" disabled>
                                        </div>

                                        <p class="change-password float-r right width-full pr_15 mb_0"> <a href="#" data-toggle="modal" data-target="#password" class="color-f5911e font-benton-bold heading-text-14 line-height-16"> Change Password </a> </p>

                                        <div class="form-group float-l width-full p_15">
                                            <p class="select-box-label color-888888 heading-text-13 line-height-17 font-benton-book mb_0"> Email Address </p>
                                            <input type="text" class="form-control custom-select" :placeholder="email" disabled>
                                        </div>
                                    </div> <!--top section-->

                                    <div class="btm-label-section float-l width-full bgcolor-f5f5f5"> <!--bottom section-->
                                        <div class="form-group float-l width-full p_15">
                                            <p class="select-box-label color-888888 heading-text-13 line-height-17 font-benton-book mb_0"> Dayforce ID</p>
                                            <input type="text" class="form-control custom-select" :placeholder="emp_id" disabled>
                                        </div>

                                        <div class="form-group float-l width-full p_15">
                                            <p class="select-box-label color-888888 heading-text-13 line-height-17 font-benton-book mb_0"> Timezone </p>
                                            <v-select v-model="timezoneId" :clearable=false name="timezoneId" placeholder="Select Timezone."
                                                    label="text"
                                                    :options="timezoneArr">
                                            </v-select>
                                            <!-- <span> <i class="fa fa-angle-down"></i> </span> -->
                                        </div>

                                        <p class="color-333333 heading-text-16 line-height-18 font-benton-bold ucase pl_15 mt_20 float-l colpie-70"> Section / Role </p>
                                        <button type="submit" class="btn btn-primary internal-large-btn internal-large-btn-blue float-l colpie-30 mt_15 float-r">
                                            <span class="gradient"></span> Add
                                        </button>

                                        <div class="form-group btm-web-role-section float-l width-full p_15">
                                            <p class="select-box-label color-888888 heading-text-13 line-height-17 font-benton-book mb_0"> Section </p>
                                            <select name="cars" class="custom-select">
                                                <option selected>Rental</option>
                                                <option value="volvo">ABC</option>
                                                <option value="fiat">XYZ</option>
                                                <option value="audi">ABC</option>
                                            </select>
                                            <span> <i class="fa fa-angle-down"></i> </span>
                                        </div>

                                        <div class="form-group btm-web-role-section float-l width-full p_15">
                                            <p class="select-box-label color-888888 heading-text-13 line-height-17 font-benton-book mb_0"> Role </p>
                                            <select name="cars" class="custom-select">
                                                <option selected>Admin</option>
                                                <option value="volvo">User</option>
                                            </select>
                                            <span> <i class="fa fa-angle-down"></i> </span>
                                        </div>

                                        <div class="register-btn float-l col-12">
                                            <button type="update" class="btn btn-primary internal-large-btn float-l mr_20"  v-on:click="createUser()">
                                                <span class="gradient"></span> Update
                                            </button>

                                            <button type="submit" class="btn btn-primary internal-large-btn internal-small-btn float-l" v-on:click="backToUser()">
                                                <span class="gradient"></span> Back
                                            </button>

                                        </div>
                                    </div> <!--bottom section-->
                                </div> 
                            </div>
                        </div> <!--middle section-->	
                    </div>

                    <div class="modal fade forward-chat-modal email-chat-modal" id="password" tabindex="-1" role="dialog" aria-labelledby="password" aria-hidden="true"> <!--Change Password modal popup--> 
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                    <h4 class="modal-title" id="myModalLabel">Change Password</h4>
                                </div>

                                <div class="modal-body email-chat-main float-l width-full p_0">
                                    <div class="form-group float-l width-full p_15">
                                        <input type="password" name="email" placeholder="Enter your Password" onfocus="this.placeholder = ''" onblur="this.placeholder = 'Enter your Password'" class="form-control custom-select">
                                    </div>

                                    <div class="form-group float-l width-full p_15">
                                        <input type="password" name="email" placeholder="Confirm your Password" onfocus="this.placeholder = ''" onblur="this.placeholder = 'Confirm your Password'" class="form-control custom-select">
                                    </div>
                                </div>

                                <div class="chat-forward-btm float-l width-full relative pl_15 pr_15">                                
                                    <button type="update" class="btn btn-primary internal-large-btn float-l mr_20">
                                        <span class="gradient"></span> Send
                                    </button>

                                    <button type="submit" class="btn btn-primary internal-large-btn internal-small-btn float-l">
                                        <span class="gradient"></span>  Cancel
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div> <!--Change Password modal popup-->
                </template>
                <template v-else>
                    <template v-if="isRequestComplete">
                        <div class="col-md-12">
                            <div class="error-template">
                                <h1>
                                    Oops!</h1>
                                <h2>
                                    403 </h2>
                                <div class="error-details">
                                    Sorry!, You don't have permission to access this page.
                                </div>
                            </div>
                        </div>
                    </template>
                </template>
            </div> 
        </div>
        <app-footer></app-footer>
    </div>
</template>

<script>
    import Vue from "vue";
    import Footer from "@/components/partials/Footer";
    import {HTTP} from '../../http-common';
    import {commonMixins} from '../../mixins/commonMixins';
    import moment from 'moment';
    import EventBus from '../event-bus';

    import VueGoodTable from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css';
    Vue.use(VueGoodTable);

    import vSelect from 'vue-select';
    Vue.component('v-select', vSelect);
    // import 'vue-select/dist/vue-select.css';

    Vue.component("app-footer", Footer);
    export default {
        name: 'UserEdit',
        mixins: [commonMixins],
        data () {
            return {
                cantAccessPage: true,
                isRequestComplete: false,
                name: '',
                email: '',
                password: '',
                cpassword: '',
                emp_error_msg: '',
                emp_id: '',
                timezoneArr: [],
                timezoneId: {
                    text: 'US: Pacific Time',
                    value: 1
                },
                sectionId: '',
                sectionArr: [],
                roleId: '',
                roleArr: [],
                generateSectionArr: [],
                blockRemoval: true,
                isHide: false,
                pType: 'password',
                cType: 'password',
                btnText: 'Register'
            }
        },
        mounted: function() {
            var self = this;
            EventBus.$emit("headerMobileView", 'User Create');
            self.loadTimezone();
            self.loadRoles();
            self.loadSection();

            self.isHide = false;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3]) {
                self.isHide = true;
                self.btnText = 'Edit';
                self.loadUser(segments[3]);
            }
            self.getPermissions();
        },
        watch: {
            generateSectionArr() {
                var self = this;
                self.blockRemoval = self.generateSectionArr.length <= 1
            }
        },
        filters: {
            filterUSting(data) {

                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            }
        },
        methods: {
            backToUser: function() {
                var self = this;
                self.$router.push("/user/list/");
            },
            removeLine (lineId, id) {
        
                var self = this;
                if (id == 0) {
                    if (!self.blockRemoval) self.generateSectionArr.splice(lineId, 1)
                } else {
                    self.generateSectionArr.splice(lineId, 1);
                }
            },
            addLine () {
                
                var self = this;
                var index = self.generateSectionArr.length - 1;
                self.generateSectionArr[index].section_error_msg = "";
                self.generateSectionArr[index].role_error_msg = "";

                if (index + 1 < self.sectionArr.length && self.generateSectionArr[index].sectionId != null && self.generateSectionArr[index].roleId) {
    
                    self.generateSectionArr.push({
                        roleId: null,
                        sectionId: null,
                        section_error_msg: "",
                        role_error_msg: "",
                    })

                } else {
                    if (self.generateSectionArr[index].sectionId == null || !self.generateSectionArr[index].sectionId.value) {
                        self.generateSectionArr[index].section_error_msg = "Section is Required.";
                    }

                    if (self.generateSectionArr[index].roleId == null || !self.generateSectionArr[index].roleId.value) {
                        self.generateSectionArr[index].role_error_msg = "Role is Required.";
                    }
                }
                
            },
            loadTimezone: function() {
                var self = this;

                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                };

                HTTP.get("get-timezone", config)
                        .then(function (data) {
                            if (data.data.code == 200 && data.data.status == 'success') {
                                self.timezoneArr = data.data.content;
                            }
                        })
                        .catch(function (error) {
                            self.catchHandler(error, function () {});
                        })
            },
            loadRoles: function() {
                var self = this;

                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                };

                HTTP.get("get-role", config)
                        .then(function (data) {
                            if (data.data.code == 200 && data.data.status == 'success') {
                                self.roleArr = data.data.content;
                            }
                        })
                        .catch(function (error) {
                            self.catchHandler(error, function () {});
                        })
            },
            loadSection: function() {
                var self = this;

                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                };

                HTTP.get("get-sections", config)
                        .then(function (data) {
                            if (data.data.code == 200 && data.data.status == 'success') {
                                self.sectionArr = data.data.content;
                                self.generateSectionArr = [];

                                var path = window.location.pathname;
                                var segments = path.split("/");
                                if (!segments[3]) {
                                    self.generateSectionArr.push({
                                        roleId: null,
                                        sectionId: null,
                                        section_error_msg: "",
                                        role_error_msg: "",
                                    });
                                }
                            }
                        })
                        .catch(function (error) {
                            self.catchHandler(error, function () {});
                        })
            },
            getUserDetails: function() {

                var self = this;
                var error = false;
                self.emp_error_msg = "";
                self.email = "";
                self.name = "";

                if(!self.emp_id && self.emp_id == '') {
                    self.emp_error_msg = "Enter Employee Id.";
                    error = true;
                }

                if(!error) {

                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                        params: {
                            'emp_id': self.emp_id
                        }
                    };

                    HTTP.post("get-user-info", config)
                            .then(function (data) {
                                if (data.data.code == 200 && data.data.status == 'success') {
                                    self.name = data.data.content.name;
                                    self.email = data.data.content.username;
                                }
                            })
                            .catch(function (error) {
                                error.response.data.message = "Please Enter Valid Deforce Id!";
                                self.catchHandler(error, function () {});
                            })
                    
                }
            },

            createUser: function() {

                var self = this;
                var error = false;

                self.emp_error_msg = '';

                if(!self.emp_id && self.emp_id == '') {
                    self.emp_error_msg = "Enter Employee Id.";
                    error = true;

                } else {

                    this.$validator.validateAll().then((result) => {
                        if (result) {
                            
                            for (var i=0; i<self.generateSectionArr.length; i++) {

                                self.generateSectionArr[i].section_error_msg = "";
                                self.generateSectionArr[i].role_error_msg = "";

                                if (self.generateSectionArr[i].sectionId == null || !self.generateSectionArr[i].sectionId.value) {
                                    self.generateSectionArr[i].section_error_msg = "Section is Required.";
                                    error = true;
                                }
                                if (self.generateSectionArr[i].roleId == null || !self.generateSectionArr[i].roleId.value) {
                                    self.generateSectionArr[i].role_error_msg = "Role is Required.";
                                    error = true;
                                }
                            }

                            if(!error) {

                                var getRoleArr = [];
                                var getSectionArr = [];

                                var path = window.location.pathname;
                                var segments = path.split("/");
                                var apiURL = "craete-user";
                                if(segments[3] && segments[3] > 0) {
                                    apiURL = "update-user";
                                }

                                var rolesData = '';
                                var sectionsData = '';
                                for (var i = 0; i < self.generateSectionArr.length; i++) {
                                    sectionsData += (self.generateSectionArr[i].sectionId.value) + ',';
                                    rolesData += (self.generateSectionArr[i].roleId.value) + ',';
                                }
                                sectionsData = sectionsData.replace(/,\s*$/, "");
                                rolesData = rolesData.replace(/,\s*$/, "");

                                var fields = {
                                    email: self.email,
                                    password: self.password,
                                    emp_id: self.emp_id,
                                    name: self.name,
                                    sections: sectionsData,
                                    roles: rolesData,
                                    timezone: self.timezoneId.value,
                                    device_type: null,
                                    device_token: null,
                                    id: segments[3],
                                };
                                var config = {
                                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                                };

                                HTTP.post(apiURL, fields, config)
                                    .then(function (data) {

                                        if (data.data.status == 'success') {
                                            if(segments[3] && segments[3] > 0) {
                                                if(data.data.display_message != '') {
                                                    // alert("Hello");
                                                    self.$swal({
                                                        // title: 'Success',
                                                        text: data.data.display_message,
                                                        type: 'info',
                                                        confirmButtonText: 'Ok',
                                                        showLoaderOnConfirm: true
                                                    })
                                                } else {
                                                    self.$router.push("/user/list/");        
                                                }
                                            } else {
                                                self.$router.push("/user/list/");
                                            }
                                        }
                                    })
                                    .catch(function (error) {
                                        //console.log(error);
                                        self.catchHandler(error, function () {});
                                    })
                            }
                        }
                    });
                }
            },
            loadUser: function(id) {
                var self = this;
                var fields = {
                    'user_id': id
                }
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                };
                //self.showLoader();
                HTTP.post("get-user-by-id", fields, config)
                    .then(function (response) {
                        if (response.data.code == '200') {
                            if (response.data.status == "success") {
                                self.emp_id = (response.data.content.emp_id != null) ? response.data.content.emp_id : '';
                                self.email = response.data.content.username;
                                self.name = response.data.content.name;
                                self.timezoneId = {text: response.data.content.tzName, value: response.data.content.timezone};
                                self.generateSectionArr = [];
                                if(response.data.userRoleSection && response.data.userRoleSection.length > 0) {
                                    setTimeout(function() {
                                        $.each(response.data.userRoleSection, function(index) {
                                            var model = response.data.userRoleSection[index];
                                            self.generateSectionArr.push({
                                                roleId: {text: model.role, value: model.roleId},
                                                sectionId: {text: model.sections, value: model.sectionId},
                                                section_error_msg: "",
                                                role_error_msg: "",
                                            });
                                        });
                                    },500);                             
                                } else {
                                    self.generateSectionArr.push({
                                        roleId: null,
                                        sectionId: null,
                                        section_error_msg: "",
                                        role_error_msg: "",
                                    });
                                }
                            }
                        }
                        //self.hideLoader();
                    })
                    .catch(function (err) {
                        //self.hideLoader();
                        self.catchHandler(error, function () {});
                    });
            },
            hideShow: function() {
                var self = this;
                self.pType = (self.pType == 'password') ? 'text' : 'password';
            },
            hideShowCPass: function() {
                var self = this;
                self.cType = (self.cType == 'password') ? 'text' : 'password';
            }
            
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->


// WEBPACK FOOTER //
// src/components/Users/UserEdit.vue